import axios from 'axios';
import config from '../config';

export const fetchCountries = () =>
  axios.request({
    method: 'get',
    url: `${config.providerApiInternal}/countries`,
  });



// WEBPACK FOOTER //
// ./src/api/countries.js